export default __webpack_public_path__ + "static/media/pic10.ae8fd5ee.jpg";